export default __webpack_public_path__ + "static/media/logo.97241382.svg";